export const deClientPortalTaskListPagePages = {
    orders: {
        taskListPage: {
            allOrders: 'Alle Aufträge',
            titleForAsset: 'Aufgaben für {{assetTitle}}',
            openTasks_one: '{{count}} offene Aufgabe',
            openTasks_other: '{{count}} offene Aufgaben',
            addTaskTooltip: 'Aufgabe hinzufügen',
            dashboard: {
                open: 'Offen',
                completed: 'Abgeschlossen',
                noDeadline: 'Keine Deadline',
                deleteTask: 'Aufgabe löschen',
                deleteConfirm: 'Löschen',
                deleteTitle: 'Aufgabe "{{taskTitle}}" wirklich löschen?',
                assigneeSearchPlaceholder: 'Nutzer durchsuchen',
            },
            create: {
                title: 'Neue Aufgabe',
                orderOption: 'Auftrag {{orderTitle}}',
                taskTitle: 'Titel',
                dueDate: 'Fälligkeitsdatum',
                assignee: 'Zuständig',
                description: 'Beschreibung',
                createMore: 'Weitere Aufgabe erstellen',
                create: 'Erstellen',
                cancel: 'Abbrechen',
            },
        },
    },
}
